import React, { useState } from "react";
// import Header from "../../Header";
import Sidebar from "../../Sidebar";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
// import FeatherIcon from "feather-icons-react/build/FeatherIcon";
// import { Link } from "react-router-dom";
import DoctorHeader from "../../../doctor/DoctorHeader";
import { Button } from "antd";
import axios from "axios";
import useToast from "../../../hooks/userToast";
const validationSchema = Yup.object().shape({
  aetTitle: Yup.string()
    .required("AET Title is required")
    .matches(
      /^[A-Za-z0-9_]+$/,
      "AET Title should only contain letters, numbers, and underscores"
    ),
  aetHost: Yup.string()
    .required("AET Host is required")
    .matches(
      /^[A-Za-z0-9._-]+$/,
      "AET Host should only contain letters, numbers, dots, dashes, and underscores"
    ),
  aetPort: Yup.number()
    .required("AET Port is required")
    .min(1, "AET Port must be greater than 0")
    .max(65535, "AET Port must be less than 65536"),
  storageDirectory: Yup.string().required("Storage Directory is required"),
  port: Yup.number()
    .required("Port is required")
    .min(1, "Port must be greater than 0")
    .max(65535, "Port must be less than 65536"),
  deviceName: Yup.string()
    .required("Device Name is required")
    .matches(
      /^[A-Za-z0-9_]+$/,
      "Device Name should only contain letters, numbers, and underscores"
    ),
  scuPort: Yup.number()
    .required("SCU Port is required")
    .min(1, "SCU Port must be greater than 0")
    .max(65535, "SCU Port must be less than 65536"),
});

const Machine = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      aetTitle: "",
      aetHost: "",
      aetPort: null, // Updated to null
      storageDirectory: "",
      port: null, // Updated to null
      deviceName: "",
      scuPort: null, // Updated to null
    },
  });

  const [loading, setLoading] = useState(false);
  const { toastSuccess, toastError } = useToast();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const payload = {
        aetHost: data.aetHost,
        aetTitle: data.aetTitle,
        aetPort: data.aetPort,
        storageDirectory: data.storageDirectory,
        port: data.port,
        deviceName: data.deviceName,
        aetitlePairs: {
          SCU: {
            ORTHANC: data.scuPort.toString(),
          },
        },
      };

      const response = await axios.post(
        "https://pusherapi.ukitss.com/api/pusher/configure",
        payload
      );

      if (response.status === 200) {
        toastSuccess("Machine registered successfully!");
        reset();
      } else {
        toastError("Failed to register machine. Please try again.");
      }
    } catch (error) {
      console.error("Error registering machine:", error);
      alert("An error occurred while registering the machine.");
    } finally {
      setLoading(false);
    }
  };

  const handleResetFields = () => {
    reset();
  };
  return (
    <>
      <DoctorHeader />
      <Sidebar
        id="menu-item17"
        id1="menu-items17"
        activeClassName="blank-page"
      />
      <>
        <div className="page-wrapper notification_index">
          {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
          <div className="content">
            <div className="main-wrapper login-body">
              <div className="container-fluid px-0">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="login-wrapper">
                      <div className="loginbox">
                        <div className="login-right">
                          <div className="login-right-wrap">
                            {/* Page Header */}
                            <div className="page-header">
                              <div className="row">
                                <div className="col-sm-12">
                                  {/* <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                      <Link to="#">Dashboard </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                      <i className="feather-chevron-right">
                                        <FeatherIcon icon="chevron-right" />
                                      </i>
                                    </li>
                                    <li className="breadcrumb-item active">
                                      Machine
                                    </li>
                                  </ul> */}
                                </div>
                              </div>
                            </div>
                            {/* /Page Header */}
                          </div>
                          <div className="container mt-4">
                            <h2>Register Machine</h2>
                            <form
                              onSubmit={handleSubmit(onSubmit)}
                              className="row"
                            >
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    AET Title{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register("aetTitle")}
                                  />
                                  {errors.aetTitle && (
                                    <small className="text-danger">
                                      {errors.aetTitle.message}
                                    </small>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    AET Host{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register("aetHost")}
                                  />
                                  {errors.aetHost && (
                                    <small className="text-danger">
                                      {errors.aetHost.message}
                                    </small>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    AET Port{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    {...register("aetPort")}
                                  />
                                  {errors.aetPort && (
                                    <small className="text-danger">
                                      {errors.aetPort.message}
                                    </small>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    Storage Directory{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register("storageDirectory")}
                                  />
                                  {errors.storageDirectory && (
                                    <small className="text-danger">
                                      {errors.storageDirectory.message}
                                    </small>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    Port <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    {...register("port")}
                                  />
                                  {errors.port && (
                                    <small className="text-danger">
                                      {errors.port.message}
                                    </small>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    Device Name{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    {...register("deviceName")}
                                  />
                                  {errors.deviceName && (
                                    <small className="text-danger">
                                      {errors.deviceName.message}
                                    </small>
                                  )}
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label>
                                    SCU Port{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    {...register("scuPort")}
                                  />
                                  {errors.scuPort && (
                                    <small className="text-danger">
                                      {errors.scuPort.message}
                                    </small>
                                  )}
                                </div>
                              </div>
                              <div className="col-12 mt-4 d-flex gap-3 justify-content-center">
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  loading={loading}
                                  className="w-25"
                                >
                                  Register
                                </Button>
                                <Button
                                  type="default"
                                  onClick={handleResetFields}
                                  className="w-25"
                                >
                                  Reset
                                </Button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default Machine;
